import styled, { css } from 'styled-components';
import { StyledTableHeadCell } from '../TableCell/TableHeadCell/styled';
export const TableHead = styled.thead `
  ${({ $stickyHeader = false }) => $stickyHeader &&
    css `
      position: sticky;
      top: 0;
      z-index: 1;
    `};

  ${StyledTableHeadCell} {
    &:first-child {
      border-bottom-left-radius: var(--table-border-radius);
    }

    &:last-child {
      border-bottom-right-radius: var(--table-border-radius);
    }
  }
`;
